import { render, staticRenderFns } from "./PopupUpgrade.vue?vue&type=template&id=37e01904&scoped=true"
import script from "./PopupUpgrade.vue?vue&type=script&lang=js"
export * from "./PopupUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e01904",
  null
  
)

export default component.exports